import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { wtFormatMoneyRoundData } from 'src/helpers/commons/utils'
import QRCode from 'qrcode'
import { FRONT_BASE_URL } from 'src/config/Request'
import { EMPLOYEE_TYPE_NAME } from 'src/views/Employees/Employees'

export const EmployeeBonusPDF = (record) => {

  const doc = new jsPDF()

  const pageWidth = doc.internal.pageSize.width
  const logo = 'assets/wil-icon.png'
  const headerHeight = 30 // Adjust this based on the height of your header
  let yPositionFirst = 40
  var totalPagesExp = '{total_pages_count_string}'
  let yPosition = 55

  doc.setTextColor('#3c4b64')
  doc.setFont('Helvetica', 'bold') //Header middle branch logo

  const addHeader = () => {
    doc.addImage(logo, 'PNG', pageWidth - 200, 4, 25, 25)
    doc.line(pageWidth - 173, 7, pageWidth - 173, 27) // Adjust the coordinates as needed

    doc.setFontSize(11)
    doc.text('WAH', pageWidth - 171, 10, { align: 'left' })
    doc.setFontSize(11)
    doc.setFont('Helvetica')
    doc.text('INDUSTRIES', pageWidth - 171, 15)
    doc.text('LIMITED', pageWidth - 171, 20)
    doc.setFontSize(9)
    doc.text('www.wahindustries.com', pageWidth - 171, 25)

    doc.setTextColor('#000000') // Set text color to black
    doc.setFont('Helvetica', 'bold')
    doc.setFontSize(12)
    const label = 'Employee Bonus Report'
    doc.text(label, 150, 10, { align: 'left' })
  }
  const addFooter = (pageNumber, totalPages) => {
    const pageHeight = doc.internal.pageSize.height
    doc.setFontSize(10)
    doc.setTextColor(100)
    const text = `Page No : ${pageNumber} `
    doc.text(text, 10, pageHeight - 10, { align: 'left' })
  }
  addHeader()


  const HeadRows = [

    {
      content: 'Sr',
      styles: { fontStyle: 'bold', halign: 'left' },
    },

    {
      content: 'Employee Name',
      styles: { fontStyle: 'bold', halign: 'left' },
    },

    {
      content: 'Designation',
      styles: { fontStyle: 'bold', halign: 'left' },
    },

    {
      content: 'Department',
      styles: { fontStyle: 'bold', halign: 'left' },
    },
    {
      content: 'Employee \nType',
      styles: { fontStyle: 'bold', halign: 'left' },
    },
    {
      content: 'No of \nBonus',
      styles: { fontStyle: 'bold', halign: 'left' },
    },
    {
      content: 'Gross \nSalary ',
      styles: { fontStyle: 'bold', halign: 'left' },
    },
    {
      content: 'Total \nAmount',
      styles: { fontStyle: 'bold', halign: 'left' },
    },
  ]

  const EmployeeBonusData = record.map((item, index) => [
    index + 1,
    { content: item.employee.full_name ? item.employee.full_name : '' },
    { content: item.employee.designation.name ? item.employee.designation.name : '' },
    { content: item.employee.department.name ? item.employee.department.name : '' },
    { content: EMPLOYEE_TYPE_NAME[item.employee.employee_type] },
    { content: item.total_bonuses ? wtFormatMoneyRoundData(item.total_bonuses, "", false) : '' },
    { content: item.salary ? wtFormatMoneyRoundData(item.salary, "", false) : '' },
    { content: item.total_amount ? wtFormatMoneyRoundData(item.total_amount, "", false) : '' },
  ])


  doc.autoTable({
    head: [HeadRows],
    body: EmployeeBonusData,
    margin: { top: headerHeight + 10, left: 7, right: 7 },
    startY: yPositionFirst,
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: '100%',
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
      cellPadding: { top: 1.0, right: 1.0, bottom: 1.0, left: 1.0 },
    },
    columnStyles: {
      0: { halign: 'left' }, // Sr
      1: { halign: 'left' }, // Employee Name
      2: { halign: 'left' }, // Designation
      3: { halign: 'left' }, // Department
      4: { halign: 'left' }, // Employee Type
      5: { halign: 'left' }, // No of Bonus
      6: { halign: 'left' }, // Gross Salary
      7: { halign: 'left' }, // Total Amount
    },
    didDrawPage: (data) => {
      addHeader()
      const pageNumber = doc.internal.getCurrentPageInfo().pageNumber
      const totalPages = doc.internal.getNumberOfPages()
      addFooter(pageNumber, totalPages)
    },
  })
  doc.addPage()

  record.map((pdfData) => {
    doc.setTextColor('#3c4b64')
    doc.setFont('Helvetica', 'bold') //Header middle branch logo

    doc.addImage(logo, 'PNG', pageWidth - 200, 4, 25, 25)
    doc.line(pageWidth - 173, 7, pageWidth - 173, 27) // Adjust the coordinates as needed

    doc.setFontSize(11)
    doc.text('WAH', pageWidth - 171, 10, { align: 'left' })
    doc.setFontSize(11)
    doc.setFont('Helvetica')
    doc.text('INDUSTRIES', pageWidth - 171, 15)
    doc.text('LIMITED', pageWidth - 171, 20)
    doc.setFontSize(9)
    doc.text('www.wahindustries.com', pageWidth - 171, 25)

    doc.setTextColor('#000000') // Set text color to black
    doc.setFont('Helvetica', 'bold')
    doc.setFontSize(12)
    const label = 'Employee Bonus Report'
    doc.text(label, 150, 10, { align: 'left' })

    const qrCodeSize = 24
    const qrCodeX = (pageWidth - qrCodeSize) / 2
    const qrCodeY = 4

    const qrCodeText = FRONT_BASE_URL + 'employee-profile?id=1' + pdfData.id
    QRCode.toDataURL(qrCodeText, { width: qrCodeSize }, (err, url) => {
      if (err) {
        console.error(err)
      } else {
        doc.addImage(url, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize)
      }
    })

    doc.setFont('helvetica', 'normal')
    doc.setTextColor('Black')

    doc.setFontSize(12)

    doc.text(`ID:`, 16, 32.5, { align: 'left' })
    doc.text(`${pdfData.employee.id ? pdfData.employee.id : ''}`, 25, 32.5, { align: 'left' })

    const textWidth = 23
    function drawLine(x1, y1, x2, y2) {
      doc.moveTo(x1, y1).lineTo(x2, y2).stroke()
    }

    const lineHeight = 1
    drawLine(23, 32.5 + lineHeight, 23 + textWidth, 32.5 + lineHeight)

    doc.text('Employee Type:', 47, 32.5, { align: 'left' })
    doc.text(`${pdfData.employee.employee_type ? pdfData.employee.employee_type : ''}`, 83, 32.5, {
      align: 'left',
    })

    const EmployeeTypeWidth = 32.5

    const lineStartX1 = 81
    const lineStartY1 = 32.5
    const lineEndX1 = lineStartX1 + EmployeeTypeWidth
    const lineEndY1 = lineStartY1

    drawLine(lineStartX1, lineStartY1 + lineHeight, lineEndX1, lineEndY1 + lineHeight)

    doc.text('Name:', 117, 32.5, { align: 'left' })
    doc.text(`${pdfData.employee.full_name ? pdfData.employee.full_name : ''}`, 133, 32.5, {
      align: 'left',
    })

    const NameWidth = 59

    const lineStartX = 132
    const lineStartY = 32.5
    const lineEndX = lineStartX + NameWidth
    const lineEndY = lineStartY

    drawLine(lineStartX, lineStartY + lineHeight, lineEndX, lineEndY + lineHeight)

    doc.text(`Designation:`, 16, 40.5, { align: 'left' })
    doc.text(`${pdfData.employee.designation ? pdfData.employee.designation.name : ''}`, 43, 40.5, {
      align: 'left',
    })

    const DesignationWidth = 54

    const DesignationLineStartX = 40.5
    const DesignationLineStartY = 40.5
    const DesignationLineEndX = DesignationLineStartX + DesignationWidth
    const DesignationLineEndY = DesignationLineStartY

    drawLine(
      DesignationLineStartX,
      DesignationLineStartY + lineHeight,
      DesignationLineEndX,
      DesignationLineEndY + lineHeight,
    )

    doc.text(`Department:`, 98, 40.5, { align: 'left' })
    doc.text(`${pdfData.employee.department ? pdfData.employee.department.name : ''}`, 125, 40.5, {
      align: 'left',
    })

    const DepartmentWidth = 72

    const DepartmentLineStartX = 123
    const DepartmentLineStartY = 40.5
    const DepartmentLineEndX = DepartmentLineStartX + DepartmentWidth
    const DepartmentLineEndY = DepartmentLineStartY

    drawLine(
      DepartmentLineStartX,
      DepartmentLineStartY + lineHeight,
      DepartmentLineEndX,
      DepartmentLineEndY + lineHeight,
    )

    doc.text(`Basic Pay:`, 16, 47.5, { align: 'left' })
    doc.text(
      `${wtFormatMoneyRoundData(pdfData.salary) ? wtFormatMoneyRoundData(pdfData.salary) : ''}`,
      41,
      47.5,
      {
        align: 'left',
      },
    )

    const BasicPayWidth = 50

    const BasicPayLineStartX = 39
    const BasicPayLineStartY = 47.5
    const BasicPayLineEndX = BasicPayLineStartX + BasicPayWidth
    const BasicPayLineEndY = BasicPayLineStartY

    drawLine(
      BasicPayLineStartX,
      BasicPayLineStartY + lineHeight,
      BasicPayLineEndX,
      BasicPayLineEndY + lineHeight,
    )

    let Table1 = [
      [
        {
          content: 'PER',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.per ? pdfData.per : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
        {
          content: 'Bonus',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.per_bonus ? pdfData.per_bonus : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
      ],
      [
        {
          content: 'ACR',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.acr ? pdfData.acr : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
        {
          content: 'Bonus',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.acr_bonus ? pdfData.acr_bonus : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
      ],
      [
        {
          content: 'Total',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.total ? pdfData.total : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
        {
          content: 'Warnings',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.warnings ? pdfData.warnings : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
      ],
      [
        {
          content: 'Warning Deduction',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.warning_deduction ? pdfData.warning_deduction : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
        {
          content: 'Warning Total',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.warning_total ? pdfData.warning_total : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
      ],
      [
        {
          content: 'Absents',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.absents ? pdfData.absents : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
        {
          content: 'Absent Bonus',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.absent_bonus ? pdfData.absent_bonus : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
      ],
      [
        {
          content: 'Absent Total',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.absent_total ? pdfData.absent_total : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
        {
          content: 'LFP',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.lfp ? pdfData.lfp : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
      ],
      [
        {
          content: 'LFP Bonus',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.lfp_bonus ? pdfData.lfp_bonus : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
        {
          content: 'Bonus On Merit',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.bonus_on_merit ? pdfData.bonus_on_merit : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
      ],
      [
        {
          content: 'Reporting Officer Bonuses',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.reporting_officer_bonuses ? pdfData.reporting_officer_bonuses : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
        {
          content: 'CEO & MD WIL Bonuses',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.ceo_bonuses ? pdfData.ceo_bonuses : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
        },
      ],
      [
        {
          content: 'Total Bonuses',
          styles: { fontStyle: 'bold', halign: 'left' },
        },
        {
          content: pdfData.total_bonuses ? pdfData.total_bonuses : 0,
          styles: { fontStyle: 'normal', halign: 'left', textColor: 'blue' },
          colSpan: 3,
        },
      ],
    ]

    doc.autoTable({
      startY: yPosition,
      margin: { top: 20 },
      // head: Table1,
      body: Table1,
      theme: 'plain',
      tableLineColor: '#3c4b64',
      tableLineWidth: 0.2,
      tableWidth: 'auto',
      headStyles: { fillColor: [217, 218, 219] },
      styles: {
        lineColor: '#3c4b64',
        lineWidth: 0.2,
        halign: 'center',
        font: 'helvetica',
        // cellPadding: { top: 0.5, right: 0.5, bottom: 0.5, left: 0.5 },
      },
      didDrawPage: function (data) { },
    })

    const Table2 = [
      [
        {
          content: 'For Accounts Department',
          styles: { halign: 'center', fontStyle: 'bold', fontSize: 10 },
        },
      ],
    ]

    const gapBetweenTable231 = 5
    const startYForTable231 = doc.autoTable.previous.finalY + gapBetweenTable231

    drawLine(65, startYForTable231 + 12, 196, startYForTable231 + 12)
    doc.setTextColor('black')
    doc.text(`Total Bonus Amount (Rs) :`, 14, startYForTable231 + 11, { align: 'left' })
    doc.setTextColor('#0202f7')
    doc.text(
      `${pdfData.total_amount ? wtFormatMoneyRoundData(pdfData.total_amount, '', false) : ''}`,
      70,
      startYForTable231 + 11,
      { align: 'left' },
    )

    drawLine(47, startYForTable231 + 20, 196, startYForTable231 + 20)
    doc.setTextColor('black')
    doc.text(`Amount In Word :`, 14, startYForTable231 + 19, { align: 'left' })
    doc.setTextColor('#0202f7')
    doc.text(
      `${pdfData.amount_in_words ? `${pdfData.amount_in_words} Rupees Only` : ''}`,
      49,
      startYForTable231 + 19,
      {
        align: 'left',
      },
    )

    const gapBetweenTables = 1
    const startYForTable12 = doc.autoTable.previous.finalY + gapBetweenTables
    doc.autoTable({
      startY: startYForTable12,
      margin: { top: 20 },
      body: Table2, // Body rows for second table
      theme: 'plain',
      tableLineColor: '#ffffff',
      tableLineWidth: 0,
      tableWidth: 'auto', // Set table width automatically
      styles: {
        lineColor: '#ffffff',
        lineWidth: 0,
        halign: 'center',
        font: 'helvetica',
        cellPadding: { top: 0.4, right: 0.4, bottom: 0.4, left: 0.4 },
      },
      didDrawPage: function (data) { },
    })

    doc.addPage()
  })

  const pdfBlob = doc.output('blob')
  const pdfUrl = URL.createObjectURL(pdfBlob)
  window.open(pdfUrl, '_blank')
}
